export const DocumentListMapper = {
  updateDTO: (values) => {
    const { files, type, saveTo, reminder } = values;
    const supplierIds = [...new Set(saveTo.suppliers.map(({ id }) => id))];
    const factoryIds = [...new Set(saveTo.factories.map(({ id }) => id))];
    const productIds = [...new Set(saveTo.products.map(({ id }) => id))];
    let _type = null;
    if (Array.isArray(type)) {
      _type = type[0];
    } else {
      _type = type;
    }
    return {
      documentLists: files.map(({ name, documentListId }) => ({
        fileName: name,
        id: documentListId,
      })),
      supplierIds,
      factoryIds,
      productIds,
      tagIds: _type
        ? [_type].map((option) => {
            if (option && option.value) {
              return option.value;
            }
            return option;
          })
        : [],
      issueDate: reminder.issueDate?.format('YYYY-MM-DD'),
      expiryDate: reminder.expiryDate?.format('YYYY-MM-DD'),
      reviewDate: reminder.reviewDate?.format('YYYY-MM-DD'),
      reminderDate: reminder.reminderDate?.format('YYYY-MM-DD'),
      reminderType: reminder.reminderType,
      note: reminder.note,
    };
  },
};
